import "./App.scss";

import Routing from "./containers/Routing/Routing";

function App() {
    return (
        <div className="App">
            <Routing />
        </div>
    );
}

export default App;
